var FcPendencyTypesInputModule = /** @class */ (function () {
    function FcPendencyTypesInputModule() {
    }
    return FcPendencyTypesInputModule;
}());
export { FcPendencyTypesInputModule };
